'use strict';
var DiscoverEmersonController = /** @class */ (function () {
    /*@ngInject*/
    function DiscoverEmersonController(DiscoverEmersonService, $state, ProductService, CommonDataService) {
        var _this = this;
        this.DiscoverEmersonService = DiscoverEmersonService;
        this.$state = $state;
        this.ProductService = ProductService;
        this.CommonDataService = CommonDataService;
        DiscoverEmersonService.getFeaturedProductsData()
            .then(function (response) {
            _this.featuredProducts = response;
            _this.CommonDataService.addAttributeProductPathsForAllItems(_this.featuredProducts);
        });
        DiscoverEmersonService.getFeaturedBrandsData()
            .then(function (response) {
            _this.featuredBrands = response;
        });
        this.shopbrands = function (brandName, brandId) {
            var filterValue = this.urlStrip(brandName) + '-B' + brandId;
            $state.transitionTo('searchResults', { searchFilter: filterValue }); // switch views to the results page.
        };
        this.shopCondition = function (conditionName, conditionId) {
            var filterValue = this.urlStrip(conditionName) + '-D' + conditionId;
            $state.transitionTo('searchResults', { searchFilter: filterValue }); // switch views to the results page.
        };
    }
    DiscoverEmersonController.prototype.$onInit = function () {
        this.getFeaturedConditions();
    };
    DiscoverEmersonController.prototype.urlStrip = function (str) {
        if (str) {
            return str.replace(/[^\w\d\s]*/g, '').replace(/\s+/g, '-');
            // strip special characters and join words with '-'
        }
        else {
            return 'undefined'; // default value brand
        }
    };
    DiscoverEmersonController.prototype.getFeaturedConditions = function () {
        var _this = this;
        this.DiscoverEmersonService.getFeaturedConditionsData()
            .then(function (response) {
            _this.ProductService.getConditionTaxonomies()
                .then(function (taxonomies) {
                response.forEach(function (item) {
                    var match = taxonomies.find(function (condition) {
                        return item.conditionName === condition.displayName;
                    });
                    if (match) {
                        item['taxonomyId'] = match.taxonomyId;
                    }
                });
                _this.featuredConditions = response.sort(function (a, b) {
                    return parseInt(a.displayOrder) > parseInt(b.displayOrder);
                });
            });
        });
    };
    return DiscoverEmersonController;
}());
export default DiscoverEmersonController;
//# sourceMappingURL=discoveremerson.controller.js.map